module.exports = __webpack_public_path__ + "static/media/placeholder-story-highlight-big.f84b53eb.png";